import {Component, OnInit} from '@angular/core';
import {AuthentificationService} from './authentification.service';
import {TransactionsService} from './transactions.service';
import {FileDownloadService} from './file-download.service';
import {AppComponent} from './app.component';

import {Router} from '@angular/router';

@Component({
    selector: 'app-order-form-provider',
    templateUrl: './templates/order-form-provider.component.html',
    styleUrls: ['./styles/order-form-provider.component.css'],
    providers: [TransactionsService, AuthentificationService, FileDownloadService]
})
export class OrderFormProviderComponent implements OnInit {
    tot: number = 0;
    selectedValue: string = "ENVOYE";
    bcf_sent_list: any;
    bcf_not_sent_list: any;
    bcf_details: any;
    id_purchase_order: number;
    invalid_from: boolean = true;
    art_price: string;
    total_price: string;
    bcf_selected: any;
    remark: string ="";

    foods = [
        {value: 'NON ENVOYE', viewValue: 'Non-Validé'},
        {value: 'ENVOYE', viewValue: 'Validé'}
    ];

    constructor(private app_component: AppComponent, private transactions_service: TransactionsService,  private router: Router, private authentification_service: AuthentificationService, private filedownloadservice: FileDownloadService) {
        this.CheckUSerSession();
        this.app_component.valTest = '/bcf';
        this.app_component.GetParent();
        
    }

    CheckUSerSession(): void {

        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    GetSentPurchaseOrder() {
        this.transactions_service.GetSentPurchaseOrder().then(result => {this.bcf_sent_list = result['list'];});
    }

    GetNotSentPurchaseOrder() {
        this.transactions_service.GetNotSentPurchaseOrder().then(result => {this.bcf_not_sent_list = result['list'];});
    }

    OrderDetails(bcf: any): void {
        this.id_purchase_order = bcf.id_purchase_order;
        this.bcf_selected = bcf;
        this.invalid_from = false;
        this.transactions_service.GetPurchaseOrderDetails(bcf.id_purchase_order).then(result => {this.remark = result['remark'] ;this.bcf_details = result['list'];});
    }

    ValidateOrder(): void {
        this.transactions_service.ValidateOrder(this.id_purchase_order, this.selectedValue).then(result => {this.invalid_from = true; this.bcf_sent_list = result['sent']; this.bcf_not_sent_list = result['not_sent']; this.bcf_details = result['list'];})
    }

    FormatPrice(price: any): string {
       return Math.round(price).toLocaleString();
  
    }
    
    DownloadPdf():void{
        this.filedownloadservice.PurchaseOrder(this.bcf_selected);
    }
    
    selected_tr: number = -1;
    Selected(value: number): void {
        this.selected_tr = value;
    }

    Color(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {

                'background-color': '#B3B6B7', //'#FFB400',
                //'color': 'orange',
            };
        }

        return styles;
    }
    
       
    ColorIndex(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {

                //'background-color': '#B3B6B7', //'#FFB400',
                'color': 'white',
            };
        }

        return styles;
    }
   
    
    ngOnInit() {

        this.GetSentPurchaseOrder();
        this.GetNotSentPurchaseOrder();
    }

}



// WEBPACK FOOTER //
// ./src/app/order-form-provider.component.ts